import React, { useState, useEffect } from "react";
import Container from "../../components/Container";
import { InputPadrao, DatePickerPadrao, BtnPadrao, SemDados, LabelPadrao } from "../../components/Base";
import { Divider, Select, Drawer } from "antd";
import * as api from "./api";
import { useFetch } from "../../components/Hooks/Conexao";
import moment from "moment";

import { connect } from "react-redux";
import { logIn, fetch, setDados } from "../../actions/index";

const culture = new Intl.NumberFormat("pt-BR", {
    style: "decimal",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
});

function Painel(props) {
    const [dados, listarDados, loading] = useFetch(() => api.getFabricantes(props.fetch));

    useEffect(() => listarDados(), []);

    return (
        <Container loading={loading} path="">
            <div >

                <table className="tabela-padrao" style={{ marginTop: 20 }}>
                    <thead>
                        <th>Fabricante</th>
                        <th>Produtos Vinculados</th>
                    </thead>
                    <tbody>
                        {(dados || []).map((x, inx) => <tr>
                            <td>{x.fabricante}</td>
                            <td>{culture.format(x.qtd)}</td>
                        </tr>)}
                    </tbody>
                </table>

                <pre>{JSON.stringify(dados, null, 2)}</pre>
            </div>
        </Container >
    );
}

export default connect(null, { logIn, fetch })(Painel);
